
/* eslint-disable @typescript-eslint/dot-notation */
import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { NotValidAccessTokenException } from '@/exсeptions/NotValidAccessTokenExceptions';
import { NotValidSubscriptionIdException } from '@/exсeptions/NotValidSubscriptionIdExceptions';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { getAccessToken } from '@/utils/auth/token.utils';
import { EnvUtils } from '@/utils/env.utils';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { HttpClient } from '../HttpClient';
import { IHttpClientConfig } from '../HttpClient.interface';
import { HttpStatusCode } from '../HttpStatusCodes';
import { browserHistory } from '@/routing/browserHistory';
import { ExceptionTypes } from '@/config/LogEventTypes.config';
import { appInsights } from '@/services/Telemetry/AppInsights.service';


export const upliftHttpAbortController = new AbortController();

const clientConfig: IHttpClientConfig = {
  baseURL: process.env.REST_SERVER_ENDPOINT_UPLIFT,
  signal: upliftHttpAbortController.signal,
};

export const upliftHttpClient = new HttpClient(clientConfig);

const requestInterceptor = async (config: InternalAxiosRequestConfig) => {
  if (!config?.headers) {
    throw new Error('Can\'t get request headers');
  }

  const accessToken = await getAccessToken();
  const subscriptionId = await getSubscriptionId();

  if (!accessToken) {
    throw new NotValidAccessTokenException();
  }

  if (!subscriptionId) {
    throw new NotValidSubscriptionIdException();
  }

  config.headers['subscriptionid'] = subscriptionId;
  config.headers['Authorization'] = `Bearer ${accessToken}`;

  return config;
};

const responseInterceptor = async (config: AxiosResponse) => {
  return config;
};

const onRejectedResponse = (error: any) => {
  if (EnvUtils.isProduction()) {
    appInsights.trackException({ error: new Error(error.message) }, {
      exceptionType: ExceptionTypes.HTTP_EXCEPTION,
      pageUrl: window.location.href,
      subscriptionid: error?.config?.headers?.subscriptionid,
    });
  }

  if (error.response.status === HttpStatusCode.FORBIDDEN) {
    browserHistory.push(getParameterizedLink('/not-authorized'));
  }

  return Promise.reject(error);
};

upliftHttpClient.addRequestInterceptor(requestInterceptor, undefined, {
  runWhen: () => !EnvUtils.nodeEnvIs('test'),
});

if (!EnvUtils.nodeEnvIs('test')) {
  upliftHttpClient.addResponseInterceptor(responseInterceptor, onRejectedResponse);
}
